const account = {
  label: 'MY ACCOUNT',
  href: '/my-account',
};
const myBox = {
  label: 'MY BOX',
  href: '/my-box',
};
const orderHistory = {
  label: 'INVOICE HISTORY',
  href: '/my-account/#!orders',
};

export const activateMembership = {
  label: 'ACTIVATE MEMBERSHIP',
  href: '/activate-membership',
};

export const links = [
  account,
  myBox,
  orderHistory,
];

export const notSubscribedLinks = [
  myBox,
  orderHistory,
];
